<template>
  <div class="mainMonitor">
    <transition name="el-zoom-in-center">
      <div class="treeContain" v-show="showPage" v-loading="loading">
        <div class="title">{{ $t('UserListM') }}</div>
        <!-- 查询条件 -->
        <div class="serachLine">
          <el-input :placeholder="$t('pleaseEnterUseName')" clearable v-model="query.userName"> </el-input>
          <el-button type="primary" class="serachBtn" @click="searchList" size="medium">
            {{ $t('searchM') }}
          </el-button>
        </div>
        <!-- 在线用户列表 -->
        <el-tree
          :data="listData"
          node-key="id"
          default-expand-all
          :default-expanded-keys="defaultExpandIds"
          @node-expand="handleNodeExpand"
          @node-collapse="handleNodeCollapse"
          :expand-on-click-node="false"
          @node-click="handleHelmet"
          highlight-current
          class="monitorTree"
          ref="dataConfigTree"
          :props="defaultProps"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span v-if="node.childNodes.length === 0" class="onlineIcon tree-gk3-on-night"></span>
            <el-tooltip class="item" effect="dark" :content="node.label" placement="bottom">
              <span
                class="black fz16 treefamily mb2 ml2 fw500"
                :class="[node.childNodes.length === 0 && node.data.device ? 'onlineColor' : '']"
              >
                {{ node.label }}
              </span>
            </el-tooltip>
            <!-- 监控中标识 -->
            <template
              v-if="
                node.data.device &&
                  node.data.device.deviceName &&
                  listPlayVideoSerialNumber.includes(node.data.device.deviceName)
              "
            >
              <img class="marginl_auto" v-if="$store.getters.isDefaultTheme" src="../../icon/ic_jiankong.png" />
              <img class="marginl_auto" v-else src="../../icon/ic_jiankong2.png" />
            </template>
          </span>
        </el-tree>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div class="liveList" v-show="showPage">
        <div class="title">{{ $t('monitoringCenter') }}</div>
        <div class="tabLine">
          <div class="lineItem borderLeft cursor" :class="{ lineItemHight: currentIndex === 4 }" @click="changeType(4)">
            4
          </div>
          <div class="lineItem borderMid cursor" :class="{ lineItemHight: currentIndex === 6 }" @click="changeType(6)">
            6
          </div>
          <div class="broad">
            <el-tooltip class="item" effect="dark" :content="$t('broadcastOnlySent')" placement="bottom">
              <div class="open-broad" @click="showBroad" v-show="!voiceBroadcastIs">
                <img
                  class="icon_open"
                  :src="
                    require(!isDefaultTheme
                      ? '@/icon/re-new-monitor/ic_hide-m.png'
                      : '@/icon/re-new-monitor/ic_hide.png')
                  "
                  alt="打开广播"
                />
                <span class="open-title">{{ $t('OpenBroadcast') }}</span>
              </div>
            </el-tooltip>
            <transition name="moveR">
              <div class="broad-record" v-if="voiceBroadcastIs">
                <VoiceBroadcast
                  v-model="voiceBroadcastIs"
                  :listPlay="listPlayVideo"
                  @closeBroad="closeBroad"
                ></VoiceBroadcast>
              </div>
            </transition>
          </div>
        </div>
        <!-- 直播列表 -->
        <div class="help">
          <img
            class="help-icon"
            :src="require(isDefaultTheme ? '@/icon/re-new-monitor/ic_info.png' : '@/icon/re-new-monitor/help-deep.png')"
            @click="closeRealvideo"
          />
          <span>{{ $t('MonitoringVideoLiveMode') }} </span>
        </div>
        <!-- 直播列表 -->
        <ul :class="voiceBroadcastIs ? 'hide-video' : 'liveVideo'">
          <li :class="vedioStyle" v-for="item in listPlayVideo" :key="item.serialNumber">
            <!-- toolClick true:执法仪，false：管控3 用于视频工具栏是否显示 -->
            <LiveVideo ref="livechild" :device="item" @close="closeVideo" @handleVideo="handleVideo"></LiveVideo>
          </li>
        </ul>
      </div>
    </transition>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="40%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="video-title">
        <span class="title">{{ $t('InRealTimVideo') }}<span class="dotting"></span></span>
        <span class="title-tip">{{ $t('VoiceVideoCallBetween') }}</span>
        <img
          v-if="isDefaultTheme"
          class="video-close"
          :src="require('@/icon/monitor/close.png')"
          @click="closeRealvideo"
        />
        <img v-else class="video-close" :src="require('@/icon/real-video/close.png')" @click="closeRealvideo" />
      </div>
      <div class="reaVideo-box">
        <Realvideo
          v-if="rtcType === 'trtc'"
          :device.sync="realVideoData"
          :currentItem="currentItem"
          :deviceName="deviceName"
          :allowClick="allowClick"
          :liveBroadcast="liveBroadcast"
          @handleClose="handleClose"
          ref="HandleRealvideo"
        ></Realvideo>
        <RealVideoSrs
          v-else-if="rtcType === 'srs'"
          :device.sync="realVideoData"
          :currentItem="currentItem"
          :deviceName="deviceName"
          :allowClick="allowClick"
          :liveBroadcast="liveBroadcast"
          @handleClose="handleClose"
          ref="HandleRealvideo"
        ></RealVideoSrs>
        <RealVideoMediasoup
          v-else-if="rtcType === 'mediasoup'"
          :device.sync="realVideoData"
          :currentItem="currentItem"
          :deviceName="deviceName"
          :allowClick="allowClick"
          :liveBroadcast="liveBroadcast"
          @handleClose="handleClose"
          ref="HandleRealvideo"
        ></RealVideoMediasoup>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Realvideo from '@/views/monitor/index/RealVideo.vue'
import RealVideoSrs from '@/views/monitor/index/RealVideoSrs.vue'
import RealVideoMediasoup from '@/views/monitor/index/RealVideoMediasoup.vue'
import VoiceBroadcast from '@/components/voiceBroadcast/VoiceBroadcast.vue'
import LiveVideo from '@/views/monitor/live/LiveVideo.vue'
import { findDeviceList } from '@/api/monitor'
import { warning, getSession, nowDateTime, delSession } from '@/api/common'
import { confirmWin, deepClone } from '@/util/common'
import { setHandleHelmetOperationResponse, sendLiveUrlRequest, exitLiving, grabRecord } from '@/common/websocket/live'
import { errorCollection } from '@/api/dmp/dmpCollection'
import { mapGetters } from 'vuex'
import { getLiveUrl } from '@/common/live'
import { helmetInfo } from '@/api/log/operation'
import { getLogin } from '@/api/login'
import { creatGK3Socket } from '@/common/websocket/index'
import { loginMVCPUtil } from '@/common/rtc/mediasoup/mediasoup-util'
import { register } from '@/common/rtc/srs/video-platform'
import { loginStorage } from '@/common/loginStorage'
import md5 from 'js-md5'

export default {
  data() {
    return {
      showPage: false,
      currentIndex: 4,
      // 列表查询条件
      query: {
        userName: '',
        // 查询状态集合，0-离线，1-在线，2-未绑定
        statusList: [1],
        // 仅查询 智能安全帽
        specType: 1,
        // 查询 智能安全帽\执法仪\国标智能安全帽
        specTypeList: [1, 2, 3],
      },
      // 列表数据
      listData: [],
      // 播放视频设备列表
      listPlayVideo: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      liveUrl: '',
      resolutionP: '',
      vedioStyle: 'fourClass',
      toolClick: false,
      timeSetInterval: null,
      // 租户点击后的loading  防止过快点击打开，视频加载不出
      loading: false,
      // 显示实时视频弹窗
      dialogVisible: false,
      // 实时视频相关
      realVideoData: {
        serialNumber: null,
        username: null,
      },
      // 当前选中的安全帽设备信息
      currentItem: null,
      allowClick: false,
      deviceName: '',
      liveBroadcast: {
        currentNode: {},
        IsLive: true,
      },
      voiceBroadcastIs: false,
      // 是否有在语音通话中
      playingWaike: false,
      // 第一个节点
      firstOuId: '',
      // 这里存放要默认展开的节点 id
      defaultExpandIds: [],
      helmetInfo: null,
      // 账户名
      userName: '',
      // 登录密码
      password: '',
      // 当前时间 yy-mm-nn
      timestamp: '',
      // 用户id
      userId: '',
    }
  },
  methods: {
    // 获取地址栏参数
    getQueryVariable(name) {
      try {
        var url = window.location.href
        if (url.indexOf('?') === -1) {
          return ''
        }
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var r = url.split('?')[1].match(reg)
        if (r != null) {
          return r[2]
        }
        return ''
      } catch (e) {
        return ''
      }
    },
    // 请求登录接口、登录成功后连接websocket服务
    login() {
      let params = {
        data: {
          username: this.username,
          password: this.password,
          grant_type: 'password',
          auth_type: 'ak_sk',
          timestamp: this.timestamp,
        },
      }
      getLogin(params).then(val => {
        let state = val.state
        let res = val
        if (state === 0) {
          this.showPage = true
          if (!this.isCloud) {
            this.getCloudRoomUrl()
          }
          this.loginErrorHint = ''
          this.$store.dispatch('alterName', res.username)
          // 参数储存
          loginStorage(res)
          creatGK3Socket()
          this.searchList()
          // 自定义消息响应处理
          setHandleHelmetOperationResponse(this.handleHelmetOperationResponse)
          this.timeSetInterval = setInterval(() => {
            if (getSession('access_token')) {
              this.searchList()
              this.getHasVideo()
            }
          }, 20000)
        } else {
          console.log('登录失败')
          this.$notify({
            title: '提示',
            message: ' 密钥无效，请重新获取',
            duration: 3000,
          })
        }
      })
    },
    getCloudRoomUrl() {
      if (this.rtcType === 'srs') {
        //  连接注册新媒体平台 服务
        register()
      } else if (this.rtcType === 'mediasoup') {
        // 连接mediasoup
        loginMVCPUtil()
      }
    },
    // 展开全部
    openALL() {
      for (let item of this.listData) {
        if (item.id) {
          this.handleNodeExpand(item)
        }
        this.addChildrenIds(item)
      }
    },
    // 循环展开树子节点
    addChildrenIds(data) {
      const _this = this
      if (data.children) {
        data.children.forEach(function(item) {
          if (item.id) {
            _this.handleNodeExpand(item)
          }
          if (item.children) {
            _this.addChildrenIds(item)
          }
        })
      }
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false
      this.defaultExpandIds.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true
          return
        }
      })
      if (!flag) {
        // 不存在则存到数组里
        this.defaultExpandIds.push(data.id)
      }
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      if (data.id === this.firstOuId) {
        this.defaultExpandIds = []
        return
      }
      // 删除当前关闭的节点
      this.defaultExpandIds.some((item, i) => {
        if (item === data.id) {
          this.defaultExpandIds.splice(i, 1)
        }
      })
      if (data.children) {
        this.removeChildrenIds(data) // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
      }
    },
    // 删除树子节点
    removeChildrenIds(data) {
      const ts = this
      if (data.children) {
        data.children.forEach(function(item) {
          const index = ts.defaultExpandIds.indexOf(item.id)
          if (index > 0) {
            ts.defaultExpandIds.splice(index, 1)
          }
          if (item.id) {
            ts.removeChildrenIds(item)
          }
        })
      }
    },
    // 当有播放监控的时候才展开广播聊表
    showBroad() {
      if (this.listPlayVideo.length === 0) {
        this.$message({
          message: this.$t('openMonitoringVideoFirst') + '！',
          type: 'warning',
        })
        return
      }
      this.voiceBroadcastIs = true
    },
    closeBroad() {
      this.voiceBroadcastIs = false
    },
    // 关闭实时视频
    closeRealvideo() {
      this.$refs.HandleRealvideo.close()
      this.dialogVisible = false
    },
    // 开启实时视频模式
    handleVideo(data) {
      this.closeVideo(data.device.serialNumber)
      this.dialogVisible = true
      this.realVideoData = {
        serialNumber: data.device.serialNumber,
        username: data.name,
      }

      this.currentItem = data.device
      this.deviceName = data.device.deviceName
      this.liveBroadcast.currentNode = data
      this.allowClick = data.device.specType === 1 ? false : true
    },
    // 关闭实时视频弹窗
    handleClose() {
      this.dialogVisible = false
      setTimeout(() => {
        if (!this.listPlayVideoSerialNumber.includes(this.liveBroadcast.currentNode.serialNumber)) {
          sendLiveUrlRequest(this.liveBroadcast.currentNode.serialNumber, 0)
          this.listPlayVideo.push({
            // 设备所有者姓名
            name: this.liveBroadcast.currentNode.name,
            // 设备序列号
            serialNumber: this.liveBroadcast.currentNode.serialNumber,
            // 播放地址
            liveUrl: null,
            resolutionP: 0,
            userId: this.liveBroadcast.currentNode.userId,
            specModel: this.liveBroadcast.currentNode.specModel,
            toolClick: this.toolClick,
            device: this.currentItem,
            currentNode: this.liveBroadcast.currentNode,
          })
        }
      }, 1500)
      this.realVideoData = {
        serialNumber: null,
        username: null,
      }
      // 重定义消息响应事件
      setHandleHelmetOperationResponse(this.handleHelmetOperationResponse)
    },
    // 查询列表数据
    searchList() {
      findDeviceList(this.query).then(res => {
        if (res.state === 0 && res.data[0]) {
          this.listData = res.data
          this.firstOuId = res.data[0].id
          if (this.defaultExpandIds.indexOf(this.firstOuId) === -1) {
            this.defaultExpandIds.push(this.firstOuId)
          }
        } else {
          this.listData = []
        }
      })
    },
    getHasVideo() {
      if (this.listPlayVideo && this.listPlayVideo.length > 0) {
        for (let i = 0; i < this.listPlayVideo.length; i++) {
          let param = deepClone(this.query)
          param.userName = this.listPlayVideo[i].name
          findDeviceList(param).then(res => {
            if (!res.data[0]) {
              exitLiving(this.listPlayVideo[i].serialNumber)
              this.listPlayVideo.splice(i, 1)
              // 若没有视频在播放  关闭广播
              if (this.listPlayVideo.length === 0) {
                this.closeBroad()
                this.$store.commit('openVedio', false)
              }
            }
          })
        }
      }
    },
    handleWaikeHelmet(value) {
      this.playingWaike = false
      let waikeHelmet = []
      if (this.showWaike && this.waikIngInfo && this.waikIngInfo.userList) {
        for (let item of this.waikIngInfo.userList) {
          waikeHelmet.push(item.helmetId)
        }
        // 判断当前点击查看直播的是否在语音通话
        if (waikeHelmet.indexOf(value.device.serialNumber) !== -1) {
          this.playingWaike = true
          return
        }
      }
    },
    handleHelmet(val) {
      helmetInfo(val.userId).then(res => {
        if (res.state === 0 && res.value) {
          if (res.value && res.value.pattern && res.value.pattern === 3) {
            warning(this.$t('patternMode'))
            return
          } else {
            this.handleNodeClick(val)
          }
        }
      })
    },
    // 机构树点击事件
    async handleNodeClick(data) {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 1000)
      await this.handleWaikeHelmet(data)
      if (this.playingWaike) {
        warning(this.$t('deviceInVoiceCall'))
        return
      }
      // 点击节点 为设备并且不在播放列表
      if (
        data.device &&
        data.device.serialNumber &&
        !this.listPlayVideoSerialNumber.includes(data.device.serialNumber)
      ) {
        // 为频繁关闭打开做延迟处理
        setTimeout(() => {
          sendLiveUrlRequest(data.device.serialNumber, 0)
        }, 1000)
        this.toolClick = data.device.specType === 2 ? true : false
        this.listPlayVideo.push({
          // 设备所有者姓名
          name: data.name,
          // 设备序列号
          serialNumber: data.device.serialNumber,
          specType: data.device.specType,
          // 播放地址
          liveUrl: null,
          resolutionP: 0,
          userId: data.userId,
          specModel: data.device.specModel,
          toolClick: this.toolClick,
          device: data.device,
          currentNode: data,
        })
        this.$store.commit('openVedio', true)
      }
    },
    changeList() {
      // 视频长度作为改变 vedio class =>用于改变 box： width height
      if (this.listPlayVideo.length <= 4) {
        this.vedioStyle = 'fourClass'
      } else if (this.listPlayVideo.length >= 4) {
        this.vedioStyle = 'sixClass'
      }
    },
    // 自定义处理获取到直播链接事件
    handleLiveUrlResponse(serialNumber, liveUrl, resolutionP) {
      liveUrl = getLiveUrl(liveUrl)
      let index = this.listPlayVideoSerialNumber.indexOf(serialNumber)
      if (serialNumber && index !== -1) {
        let playVideo = this.listPlayVideo[index]
        playVideo.liveUrl = liveUrl
        playVideo.resolutionP = resolutionP
        this.$set(this.listPlayVideo, index, playVideo)
      }
    },
    // 关闭直播视频
    closeVideo(serialNumber) {
      let index = this.listPlayVideoSerialNumber.indexOf(serialNumber)
      console.log(serialNumber, 'index')
      if (serialNumber && index !== -1) {
        this.listPlayVideo.splice(index, 1)
        if (this.listPlayVideo.length === 0) {
          this.closeBroad()
          this.$store.commit('openVedio', false)
        }
      }
      exitLiving(serialNumber)
    },
    // 直播时处理websocket响应
    handleHelmetOperationResponse(params) {
      console.log(params)
      // action:0=加入，1=离开，2=切换分辨率，3=直播进入，4=直播停止
      // {"action":1,"camera":0,"gps":0,"laser":0,"led":0,"readdingLamp":0,"rfid":0,"warnningLamp":0}
      // {"action":0,"ihVersion":"21","isAgoraSpeech":false,"isAudioRecord":false,"isFaceScan":false,"isQRScan":false,
      // "isRecord":false,"isRecordVoiceOpen":true,"isSwitchUser":false,"isWebRtcConnect":false,"netWorkState":1,"roomId":0}
      // {"action": 2,"enterResult":false}
      // {"cloudRoomType":"3","channelId":"H-100-001","status":"{\"action\":3,\"startLiveResult\":true,\"liveUrl\":\"http:xxxx\",\"errorMsgType\":0,\"roomId\":12345}"}
      var status = JSON.parse(params.status)
      // 通过头盔id获取到对应的用户名
      let name = null
      let userId = null
      let helmetIndex = this.listPlayVideoSerialNumber.indexOf(params.helmetId)
      if (helmetIndex === -1) {
        // 非播放中头盔信息，直接返回
        return
      } else {
        // 当前请求头盔id对应的用户名
        name = this.listPlayVideo[helmetIndex].name
        userId = this.listPlayVideo[helmetIndex].userId
      }
      if (status.action === 2) {
        // 头盔加入房间失败
        if (!status.enterResult) {
          console.error(name + this.$t('helmetVideoConnectionFailed'))
          errorCollection('实时监控', '安全帽视频连接', {
            status: 200,
            data: { state: -1, msg: '安全帽视频连接失败，请重新连接' },
          })
        }
        return
      }
      if (status.action === 1) {
        console.log(`拍照状态:${status.camera}`)
        return
      }
      if (status.isFaceScan) {
        warning(name + this.$t('FaceRecognitionProgress'))
        return
      }
      if (status.isQRScan) {
        warning(name + this.$t('helmetScanningQR'))
        return
      }
      if (status.isSwitchUser) {
        warning(name + this.$t('SwitchingUsers'))
        return
      }
      if (status.isAgoraSpeech) {
        warning(name + this.$t('MicrophoneOccupied'))
        return
      }
      if (status.isRecord) {
        confirmWin(
          name + this.$t('RecordingPreemptOrNot') + '？',
          () => {
            grabRecord(params.helmetId)
          },
          () => {
            // 点击取消事件 关闭直播框
            this.closeVideo(params.helmetId)
          }
        )
        return
      }
      // 开始直播或者直播切换分辨率
      if (status.action === 3) {
        if (status.errorMsgType === 1) {
          warning(name + '视频会议抢占导致直播停止')
          this.$refs.livechild[helmetIndex].clearSetTimeout()
          this.closeVideo(params.helmetId)
          this.voiceBroadcastIs = false
        } else if (status.errorMsgType === 2) {
          warning(name + '打开摄像头失败，请重试！')
        } else if (status.liveUrl) {
          this.$nextTick(() => {
            this.$refs.livechild[helmetIndex].changeReaolution(status.resolution)
          })

          if (this.$store.state.isUserSend) {
            // 延时防止快速点击多个直播时不触发直播链接
            setTimeout(() => {
              this.$store.commit('userSend', false)
              this.handleLiveUrlResponse(params.helmetId, status.liveUrl, status.resolution)
            }, 1000)
          }
        }
      }
      //当直播被会议抢占时，退出关闭视频窗口，弹窗提示
      if (status.action === 4) {
        if (status.stopEventType === 1) {
          // 视频会议抢占导致直播停止
          warning(name + '视频会议抢占导致直播停止')
          this.$refs.livechild[helmetIndex].clearSetTimeout()
          // 点击取消事件 关闭直播框
          this.closeVideo(params.helmetId)
          this.voiceBroadcastIs = false
        } else if (status.stopEventType === 0) {
          // 正常停止直播
          console.log('正常停止直播')
        }
      }
    },
    changeType(num) {
      this.currentIndex = num
      if (num === 4) {
        this.vedioStyle = 'fourClass'
      } else {
        this.vedioStyle = 'sixClass'
      }
    },
  },
  computed: {
    ...mapGetters(['isCloud', 'rtcType', 'isDefaultTheme']),
    // 播放视频序列号集合
    listPlayVideoSerialNumber() {
      return this.listPlayVideo.map(item => {
        return item.serialNumber
      })
    },
    // 语音通话中监听
    waikIngInfo() {
      return this.$store.state.yyv.waikeInfo
    },
    // 语音通话中监听
    showWaike() {
      return this.$store.state.openWaike
    },
  },
  components: {
    LiveVideo,
    Realvideo,
    RealVideoSrs,
    RealVideoMediasoup,
    VoiceBroadcast,
  },
  mounted() {
    this.username = this.getQueryVariable('appKey')
    let secretKey = this.getQueryVariable('secretKey')
    this.timestamp = nowDateTime()
    let passKey = secretKey + '.' + this.username + '.' + this.timestamp + '.' + secretKey
    this.password = md5(passKey)
    if (!this.username || !secretKey) {
      delSession('access_token')
      delSession('expireTime')
      delSession('HWSecurity_access_token')
      delSession('userId')
      sessionStorage.removeItem('featureCode')
      sessionStorage.removeItem('isAdmin')
    }
    this.login()
  },
  beforeDestroy() {
    if (this.listPlayVideo && this.listPlayVideo.length > 0) {
      for (let item of this.listPlayVideo) {
        this.closeVideo(item.serialNumber)
      }
    }
    // 退出后清空消息响应处理
    setHandleHelmetOperationResponse(() => {})
    clearInterval(this.timeSetInterval)
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
@import '~@/style/playing.styl'
.mainMonitor
  background #EEF5FE
  margin: 0!important;
  height 100%!important
  .treeContain
    position: absolute;
    top: 20px;
    left: 0;
    width 17%
    height 95%
    margin-left: 20px;
    pointer-events: auto
    background #fff
    border-radius: 4px;
    /deep/.el-tree-node__label
      font-size 16px
    .title
      padding-top: 2px;
      font-size: 18px;
      font-weight: bold;
      color: var(--title-color)
      line-height: 32px;/*no*/
      bg-image('~@/icon/re-new-monitor/img_head.png')
      padding-left: 62px;
      .voice-broadcast-but2
        margin-left: 55px;
        padding: 6px 10px 5px 10px;
        position: relative;
        top: 5px;
        img
          vertical-align: middle
          height: 16px
          margin-right: 5px
    .serachLine
      margin 20px 10px 10px 10px
      display flex
      align-items center
      justify-content center
      /deep/.el-input__inner
        color: #222
      .serachBtn
        margin-left: 5px;
        line-height: 20px;
    .monitorTree
      overflow auto
      height calc(100% - 110px)
      background-color transparent !important
      margin-top 10px
      .onlineIcon
        display inline-block
        width 20px
        height 20px
      .tree-gk3-on-night
        bg-image('~@/icon/re-new-monitor/tree-gk3-on-night.png')
  .help
    display flex
    align-items: center
    font-size 15px
    vertical-align: middle
    margin-top: 14px;
    margin-left: 180px;
    position: absolute;
    color var(--text-color)
    opacity 0.5
    .help-icon
      width 16px
      height 16px
      margin-right 5px
  .liveList
    width 80%
    height 95%
    position: absolute;
    top: 20px;
    right: 20px;
    margin-left: 20px;
    pointer-events: auto
    background #fff
    .title
      position: absolute;
      top: 0px;
      left: 0px;
      font-size: 18px;
      font-weight: bold;
      color: var(--title-color)
      line-height: 46px;/*no*/
      padding-left: 86px;
      width: 85%;
      bg-image('~@/icon/re-new-monitor/img_head2.png')
    .tabLine
      position absolute
      top: 6px;
      right: 24px;
      height 95%
      display flex
      .lineItem
        font-weight: bold;
        line-height: 30px
        text-align: center
        width: 40px;
        height: 30px;
        opacity: 0.7;
        color var(--color-bg-black)
      .lineItemHight
        background: var(--new-tab-bg-heighlight)
        opacity: 1;
        color var(--color-bg-black-heiglight)
      .borderLeft
        border-top: 2px solid var(--boredr-color);
        border-left: 2px solid var(--boredr-color);
        border-bottom: 2px solid var(--boredr-color);
      .borderMid
        border: 2px solid var(--boredr-color);
      .borderRight
        border-top: 2px solid var(--boredr-color);
        border-right: 2px solid var(--boredr-color);
        border-bottom: 2px solid var(--boredr-color);
    .liveVideo
      width: 97%;
      height: 89%;
      margin-top: 62px;
      margin-left: 33px;
      overflow-y: auto;
      li
        border: 1px solid #0BFCFF;
        border-radius: 2px;
        margin: 5px
      .fourClass
        width 49%
        height 48%
        box-sizing border-box
        float left
      .sixClass
        width: 32.3%;
        height: 48%;
        box-sizing border-box
        float left
    .hide-video
      width calc(100% - 450px);
      height: 89%;
      margin-top: 63px;
      margin-left: 33px;
      overflow-y: auto;
      li
        border: 1px solid #0BFCFF;
        border-radius: 2px;
        margin: 5px
      .fourClass
        width 49%
        height 48%
        box-sizing border-box
        float left
      .sixClass
        width 48.3%
        height 32%
        box-sizing border-box
        float left
  >>>.el-loading-mask
    opacity 0.1
.el-main
  position relative
.broad
  height 99%
  margin-left 15px
  .open-broad
    display flex
    align-items: center
    float right
    width 90px;/*no*/
    border-radius: 2px;
    padding 6px 10px
    cursor pointer
  .icon_open
    width 20px
    height 20px
    margin-right: 6px
  .broad-record
    width 390px
    height 100%
    border-radius: 4px
    border: 1px solid #DCDCDC;
.video-title
  position relative
  height: 44px
  line-height: 44px
  .title
    font-size: 18px
    margin 0 10px
  .title-tip
    height: 26px
    line-height: 26px
    display inline-block
    border-radius: 13px
    padding 0 14px
  .video-close
    float right
    width 17px
    height 17px
    margin-top 16px
    cursor pointer
.editBtn
  display none
  .addicon
    margin-right 10%
    width 30px;/*no*/
    height 30px;/*no*/
.reaVideo-box
  width 100%
  height 420px
.open-all
  padding 2px 5px
  border 1px solid #0bfcff
  margin-left: 10px
  border-radius 2px
  font-size 12px
  color #0bfcff
  margin 4px 14px
  cursor pointer
.custom-tree-node
  flex 1
  display flex
  align-items center
  justify-content flex-start
  padding-right 20px
  width 100%
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  .node-txt
    font-size 16px;/*no*/
  .marginl_auto
    margin-left auto
.el-tree-node__content:hover .editBtn
    display block
>>>.el-dialog__header
  padding 0
>>>.el-dialog__body
  height: 465px
  padding 0 10px 10px
  overflow-y visible
>>>.v-modal
  z-index 100!important
.test
  background: #ccc
  pointer-events: auto
#voice-broadcast-but
  width: 80px;
  height: 80px;
  background: var(--search-btn-bg);
  border: 1px solid rgb(15, 192, 245);
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 40px;
  position: absolute;
  left: 226px;
  bottom: 46px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  img
    padding-top: 13px
  span
    font-size: 14px;
    font-weight: 400;
    color: var(--search-btn-color);
    line-height: 18px;
.open-title
  color var(--title-color);
// 深色模式样式覆盖
.theme-dark
  .mainMonitor
    background #001143
    .treeContain
      background #002086
      .monitorTree
        .tree-gk3-on-night
          bg-image('~@/icon/re-new-monitor/tree-gk3-on-night-m.png')
      .title
        bg-image('~@/icon/re-new-monitor/img_head2-m.png')
    .liveList
      background #002086
      .title
        bg-image('~@/icon/re-new-monitor/img_head-m.png')
  .broad
    .broad-record
      border: 0.00520833rem solid #295AFF;
</style>
